import { render, staticRenderFns } from "./technical-specification-edit-modal.vue?vue&type=template&id=36c3d27e&scoped=true"
import script from "./technical-specification-edit-modal.vue?vue&type=script&lang=js"
export * from "./technical-specification-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./technical-specification-edit-modal.vue?vue&type=style&index=0&id=36c3d27e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c3d27e",
  null
  
)

export default component.exports